// ====================================================
// src/components/block/liveStreamManagement/videoEffects/registry.ts
//
// Un seul point d'inscription : pour ajouter un effet vidéo au panneau,
// créer sa classe (cf. SurroundingsEffect.tsx pour le modèle) et l'ajouter
// ici. SourceConfigModal ne boucle que sur ce tableau.
// ====================================================

import { VideoEffect } from './VideoEffect';
import { surroundingsEffect } from './SurroundingsEffect';
import { makeupEffect } from './MakeupEffect';
import { avatarEffect } from './AvatarEffect';

export const VIDEO_EFFECTS: VideoEffect<any>[] = [
  surroundingsEffect,
  makeupEffect,
  avatarEffect,
];
